/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React from "react";

import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

function VaultStatusGrid({ data }: any) {
  return (
    <Grid data={data}>
      <Column
        field="description"
        title="Description"
        className="grid-cell-font-size"
      />
      <Column
        field="amount"
        title="Net Amount (Million)"
        width="200px"
        className="grid-cell-font-size text-center"
      />
    </Grid>
  );
}

export default VaultStatusGrid;
